//DBTables
// import { DBBuilding } from "../../types/DBTables";
import { Button, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { get } from "../../../modules/server";
import Notify from "devextreme/ui/notify";
import HtmlEditor from "devextreme-react/html-editor";
import { logAndNotifyError, logErrorSilently } from "../../../modules/logger";
import { ConfirmDialogEvent } from "../../../events/ConfirmDialogEvent";

//interface IProps {}

const HelpDialog = () => {
  const [show, setShow] = useState(false);
  const [header, setHeader] = useState("");
  const [body, setBody] = useState("");

  const handleClose = () => setShow(false);

  useEffect(() => {
    PubSub.subscribe("ShowHelp", async (msg, helpId: string) => {
      const response = await get("GetSystemText/" + helpId);
      //const response = await get("GetHelp/testHelp");
      if (response.success) {
        setHeader(response.text.title);
        setBody(response.text.body);
        setShow(true);
      } else {
        logErrorSilently("Ingen hjälp hittades för " + helpId);
        Notify("Ingen hjälp hittades", "error");
      }
    });
    PubSub.subscribe("ShowMessage", async (msg, message: { title: string; body: string }) => {
      setHeader(message.title);
      setBody(message.body);
      setShow(true);
    });

    PubSub.subscribe("ShowOfflineMessage", async (msg) => {
      PubSub.publish("ShowMessage", {
        title: "Du är offline",
        body: `<p><br></p><p>Ändringar sparas lokalt på din enhet fastän du är offline under ronderingen.
För att dessa ändringar sedan ska sparas permanent behöver du åter få internetanslutning. 
Därefter sparas alla ändringar du har gjort offline vid nästa sparning online.</p><b><br>Ifall du lämnar en rondering eller uppdaterar sidan när du är offline så förlorar du de ändringar du gjort sedan du gick offline! 
Se till att spara i online-läge innan du lämnar rondering!</b>`,
      });
    });

    return () => {
      PubSub.unsubscribe("ShowHelp");
      PubSub.unsubscribe("ShowMessage");
      PubSub.unsubscribe("ShowOfflineMessage");
    };
  }, []);

  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl" centered={false} scrollable={true}>
        <Modal.Header closeButton>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HtmlEditor valueType="html" value={body} className="HtmlEditor" readOnly></HtmlEditor>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default HelpDialog;
